export const AREA_DROP_PREFIX = 'area:';

const ID_SEPARATOR = '|';

export const createAreaDropId = (schedulerConfigId: string, areaId: string): string =>
  `${AREA_DROP_PREFIX}${schedulerConfigId}${ID_SEPARATOR}${areaId}`;

export const parseAreaDropId = (id: string | number): { schedulerConfigId: string; areaId: string } | null => {
  if (typeof id !== 'string' || !id.startsWith(AREA_DROP_PREFIX)) {
    return null;
  }
  const rest = id.slice(AREA_DROP_PREFIX.length);
  const separatorIndex = rest.indexOf(ID_SEPARATOR);
  if (separatorIndex === -1) {
    return null;
  }
  return { schedulerConfigId: rest.slice(0, separatorIndex), areaId: rest.slice(separatorIndex + 1) };
};
